import React from 'react';
import {Link} from 'react-router-dom';

class Privacy extends React.Component {
    render(){
        return (
            <div className = "privacyContent">
                <div className="pageTitle"><h2>Privacy Notice</h2></div>
                <div className="pageContent">
                    <h2>Who we are</h2>
                    <p>Our website address is: https://www.mudefordquaycleanup.org.uk.</p>
                    <br/>
                    <h2>What personal data we collect and why we collect it</h2>
                    <br/>
                    <h3>Website</h3>
                    <p>We do not collect personal data on the website or store it anywhere on the web platform.</p>
                    <p>If you submit a contact form, the information that you include on that form will be sent via email, including your name and email address. This is not saved to a database. The information will be retained only for as long as required to:</p>
                        <ol>
                            <li>respond to your message</li>
                            <li>If you requested to join the mailing list, until such time as you request to be removed from that list</li>
                        </ol>
                    <br/>
                    <h3>Media</h3>
                    <p>If you upload images to the website or to our social media streams, you should avoid uploading images with embedded location data (EXIF GPS) included. Visitors to the website can download and extract any location data from images on the website.</p>
                    <br/>
                    <h3>Embedded content from other websites</h3>
                    <p>Articles on this site may include embedded content (e.g. videos, images, articles, etc.). Embedded content from other websites behaves in the exact same way as if the visitor has visited the other website.</p>
                    <p>These websites may collect data about you, use cookies, embed additional third-party tracking, and monitor your interaction with that embedded content, including tracking your interaction with the embedded content if you have an account and are logged in to that website.</p>
                    <br/>
                    <h2>Who we share your data with</h2>
                    <p>We do not share your data with any other person or organisation.</p>
                    <br/>
                    <h2>How long we retain your data</h2>
                    <p>
                    When you contact us, either through the website, directly via email or through joining the mailing list, your data will only be retained for as long as is required, which may be:
                    </p>
                    <ol>
                        <li>The time required to respond to your message</li>
                        <li>Until you request to be removed from the mailing list</li>
                    </ol>
                    <br/>
                    <h2>What rights you have over your data</h2>
                    <p>You can contact us at any time and request that we remove your data from the mailing list.</p>
                    <p>You can contact us using the <Link to='/contact'>Contact Form</Link> on this website or by emailing <a href="mailto:mudefordquaycleanup@gmail.com">mudefordquaycleanup@gmail.com</a></p>
                    <br/>
                    <h2>Where we send your data</h2>
                    <p>We do not send your data anywhere.</p>
                    <br/>
                    <h2>Additional information</h2>
                    <p>We do not collect or store your personal information. If you email us we will keep your email address only for as long as is needed to respond to your message. Your email address is not stored and will not be kept in any list, used for any purpose other than to respond to your message or passed on to any third parties.</p>
                    <br/>
                    <h2>How we protect your data</h2>
                    <p>All contact that is made goes through to our gmail account.</p>
                    <p>This account is accessible to the team lead and is secured with two-factor authentication.</p>
                    <p>The website is secured with an SSL certificate</p>
                    <p>When sending emails to the mailing list, all email addresses are protected through the use of blind copy.</p>
                    <br/>
                    <h2>What data breach procedures we have in place</h2>
                    <p>For all data protection requirements, we follow guidance from the <a rel="noreferrer noopener" href="https://ico.org.uk/" target="_blank">Information Commissioner's Office</a> and in the event of any data breach will refer to their guidance and take all necessary steps.</p>
                    <br/>
                    <h2>What third parties we receive data from</h2>
                    <p>We do not receive data from third parties</p>
                    <br/>
                    <h2>What automated decision making and/or profiling we do with user data</h2>
                    <p>We do not undertake any decision making or profiling with user data.</p>
                    <br/>
                </div>
            </div>
        )
    }
}

export default Privacy;